import { Middleware } from '@nuxt/types'
import { Feature } from '~/plugins/feature-flags'

const redirect: Middleware = ({ route, redirect, $accessor, $auth, $featureFlags }) => {
  if (window.location.pathname === '/registration/select') { return }

  const routePath = route.path.replace(/\/$/, '') // remove trailing slash

  if (routePath.indexOf('/scholarships') === 0 && routePath.indexOf('/scholarships/submitted') !== 0) {
    if ($auth.loggedIn) {
      if (!$auth.user.membership) {
        window.location.href = '/registration/select'
        // prevent rendering and other middleware execution
        return new Promise(() => {})
      } else if ($auth.user.membership?.status?.name === 'Past due') {
        window.location.href = '/my-account/membership'
        // prevent rendering and other middleware execution
        return new Promise(() => {})
      }
    }
  }

  if (routePath === '/scholarships') {
    if ($accessor.featureSet.isGame) {
      redirect('/scholarships/dashboard')
      return
    }
    if (!$accessor.account.isPro) {
      redirect('/scholarships/matches')
      return
    }
    redirect('/scholarships/recommended')
  }

  if (routePath.match(/^\/scholarships\/(matches|saved|ignored|recommended|easy)$/)) {
    if ($featureFlags?.isRolloutEligible(Feature.PhoenixScholarshipLists)) {
      window.location.href = routePath.replace('/scholarships/', '/phoenix/scholarships/')
      return new Promise(() => {})
    }
  }

  if (routePath === '/scholarships/started') {
    if ($featureFlags?.isRolloutEligible(Feature.PhoenixScholarshipLists)) {
      window.location.href = '/phoenix/scholarships/started'
      return new Promise(() => {})
    }
  }

  if (routePath.match(/^\/scholarships\/submitted(\/(?:active|closed))?$/)) {
    if ($featureFlags?.isRolloutEligible(Feature.PhoenixScholarshipLists)) {
      window.location.href = routePath
        .replace('/scholarships/', '/phoenix/scholarships/')
        .replace(/\/submitted$/, '/submitted/active')
      return new Promise(() => {})
    }
  }

  if (routePath === '/scholarships/ignored') {
    if ($accessor.account.isMaintenanceMode) {
      redirect('/scholarships/matches')
      return
    }
  }

  // Check if scholarship details page
  if (routePath.match(/^\/scholarships\/(recommended|easy|matches|started|saved|ignored|submitted)\/\d+$/)) {
    if ($featureFlags?.isRolloutEligible(Feature.NewDetailsPage)) {
      // Redirect to Phoenix namespace
      const phoenixPath = routePath.replace('/scholarships/', '/phoenix/scholarships/')
      window.location.href = phoenixPath
      return new Promise(() => {}) // Prevent further execution
    }
  }

  if (routePath.match(/^\/scholarships\/submitted\/\d+\/success$/)) {
    if ($featureFlags?.isRolloutEligible(Feature.NewApplicationSuccessPage)) {
      const phoenixPath = routePath.replace('/scholarships/', '/phoenix/scholarships/')
      window.location.href = phoenixPath
      return new Promise(() => {})
    }
  }

  if (routePath === '/mailbox') {
    if ($featureFlags?.isRolloutEligible(Feature.NewMailboxPage)) {
      window.location.href = '/phoenix/mailbox'
      return new Promise(() => {})
    }
  }
}

export default redirect
